import { render, staticRenderFns } from "./StitchedMCQEvaluate.vue?vue&type=template&id=4de7c74a&"
import script from "./StitchedMCQEvaluate.vue?vue&type=script&lang=js&"
export * from "./StitchedMCQEvaluate.vue?vue&type=script&lang=js&"
import style0 from "./StitchedMCQEvaluate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports